import React from "react";
import ReactDOM from "react-dom";
import { motion } from "framer-motion";

type Props = {
  variant?: "inline" | "floating";
  className?: string;
};

export default function AnimatedBookCallButton({ variant = "inline", className = "" }: Props) {
  const handleBookCall = () => {
    window.open("https://calendly.com/byteontechnologies/30min", "_blank", "noopener,noreferrer");
  };

  const base =
    "bg-gradient-to-r from-[#3b31f2] to-[#1094ff] text-white px-5 sm:px-6 py-3 sm:py-3.5 rounded-xl font-semibold shadow-lg hover:shadow-xl " +
    "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 " + className;

  const btn = (
    <motion.button
      aria-label="Book a free call"
      onClick={handleBookCall}
      className={
        variant === "floating"
          ? ["fixed bottom-6 right-6 z-[9999] pointer-events-auto mb-[env(safe-area-inset-bottom)] mr-[env(safe-area-inset-right)]", base].join(" ")
          : ["relative z-auto", base].join(" ")
      }
      initial={variant === "floating" ? { opacity: 0, scale: 0.8, y: 12 } : { opacity: 0, scale: 0.96 }}
      animate={variant === "floating" ? { opacity: 1, scale: 1, y: 0 } : { opacity: 1, scale: 1 }}
      transition={{ duration: 0.25, ease: "easeOut" }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.96 }}
    >
      📞 Book a Free Call →
    </motion.button>
  );

  if (variant === "floating") {
    if (typeof document === "undefined") return null; // SSR guard
    return ReactDOM.createPortal(btn, document.body);
  }
  return btn;
}